import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import clsx from 'clsx';

import { fadeUp, fadeIn, scaleIn } from '@styles/keyframes';

function FilmrPromoScreen({
  showFirstScreen,
  deviceOS,
  filmrLinks,
  onClickDownloadLink,
  isSticky,
}) {
  return (
    <ModalContent
      className={clsx(
        'relative flex flex-col justify-between h-full w-full',
        !isSticky && 'overflow-hidden',
      )}
    >
      {showFirstScreen ? (
        <React.Fragment>
          <div className="flex flex-col justify-center h-full items-center first-screen">
            <div className="relative">
              <div className="mx-auto w-14 z-10 relative">
                <img
                  css={css`
                    animation: ${fadeUp} 0.3s 0.5s ease-out forwards;
                  `}
                  className="w-14 h-14 opacity-0"
                  src="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/filmr-logo.png"
                  alt="Filmr"
                />
              </div>
              <div className="circle-inner absolute" />
              <div className="circle-outer absolute" />
            </div>
            <div className="text-center mt-6 z-10">
              <p
                css={css`
                  animation: ${fadeUp} 0.3s 0.65s ease-out forwards;
                `}
                className="uppercase text-shadow font-bold opacity-0"
              >
                Introducing
              </p>
              <p
                css={css`
                  animation: ${fadeUp} 0.3s 0.9s ease-out forwards;
                `}
                className="uppercase text-shadow font-bold opacity-0"
              >
                Filmr By InVideo
              </p>
            </div>
            <div
              css={css`
                animation: ${fadeUp} 0.3s 1.15s ease-out forwards;
                font-size: 33px;
                line-height: 40px;
              `}
              className="text-center z-10 text-shadow px-6 mt-6 opacity-0"
            >
              The easiest way to make videos on your phone is here
            </div>
          </div>
          <div className="mx-auto mb-6 first-screen">
            <img
              className="h-8 opacity-0"
              css={css`
                animation: ${fadeUp} 0.3s 1.3s ease-out forwards;
              `}
              src="https://d1nc6vzg2bevln.cloudfront.net/images/general/logo.png"
              alt="InVideo"
            />
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="content flex justify-center items-center pt-10">
            <img
              css={css`
                animation: ${fadeUp} 0.3s ease-out forwards;
              `}
              className="w-32 opacity-0"
              src="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/filmr-logo-v2.png"
              alt="Filmr Monogram"
            />
          </div>
          <div className="text-center">
            <h3
              css={css`
                animation: ${fadeUp} 0.3s 0.15s ease-out forwards;
                font-size: 26px;
              `}
              className="filmr-heading leading-8 opacity-0 text-shadow font-medium my-4 px-2"
            >
              The easiest way to make videos on your phone is here
            </h3>
          </div>

          <div
            css={css`
              animation: ${fadeUp} 0.3s 0.3s ease-out forwards;
              margin-bottom: ${isSticky ? '350px' : '0'};
            `}
            className="awards opacity-0 flex justify-center"
          >
            <img
              className="m-2 w-1/3"
              src="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/BestGoogle.svg"
              alt="Best of Google"
            />
            <img
              className="m-2 w-1/3"
              src="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/BestApple.svg"
              alt="Best of Apple"
            />
          </div>
          <div
            className={clsx(
              'center-container flex flex-col justify-center items-center text-center w-full',
              isSticky ? 'absolute bottom-0' : 'relative',
            )}
          >
            <video
              css={css`
                animation: ${fadeIn} 0.3s 0.45s ease-out forwards;
              `}
              className="filmr-video z-10 opacity-0 w-full"
              poster="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/filmr-bg.png"
              alt="Filmr"
              autoPlay
              playsInline
              loop
              muted
            >
              <source
                src="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/filmr-modal-video.webm"
                type="video/webm"
              />
              <source
                src="https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/filmr-modal-video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div
            css={css`
              animation: ${fadeIn} 0.3s 0.6s ease-out forwards;
            `}
            className={clsx(
              'bottom-strip z-10 opacity-0 w-full h-16 bottom-0 flex justify-center items-center',
              isSticky ? 'sticky' : 'absolute',
            )}
          >
            <a
              href={deviceOS === 'iOS' ? filmrLinks.iOS : filmrLinks.android}
              target="_blank"
              onClick={onClickDownloadLink}
              rel="noopener noreferrer"
              className="mx-auto"
            >
              <img
                className=""
                src={
                  deviceOS === 'iOS'
                    ? 'https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/badge-ios.svg'
                    : 'https://d2nb51khh83712.cloudfront.net/static-assets/images/filmr/badge-android.svg'
                }
                alt="App Download Link"
              />
            </a>
          </div>
        </React.Fragment>
      )}
    </ModalContent>
  );
}

export default FilmrPromoScreen;

const ModalContent = styled.div`
  /* background: linear-gradient(180deg, #3ea3fe 0%, #0387fe 100%); */
  background-color: #55a8fa;
  /* border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25); */
  /* border-radius: 10px; */
  color: #ffffff;

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      display: none;
    }
  }

  .first-screen {
    animation: fadeOut 0.3s 5.5s ease-out forwards;
  }

  .second-screen {
  }

  .bottom-strip {
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px -2px 16px rgba(0, 0, 0, 0.1),
      inset 0px 1px 0px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    /* border-radius: 0 0 10px 10px; */
  }

  .circle-inner {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    width: 160px;
    height: 160px;
    left: calc(50% - 80px);
    top: calc(50% - 80px);
    z-index: 0;

    &:after {
      content: '';
      border-radius: 50%;
      position: absolute;
      width: 240px;
      height: 240px;
      top: calc(50% - 120px);
      left: calc(50% - 120px);
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
    &:before {
      content: '';
      border-radius: 50%;
      position: absolute;
      width: 320px;
      height: 320px;
      top: calc(50% - 160px);
      left: calc(50% - 160px);
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
  .circle-outer {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    width: 400px;
    height: 400px;
    left: calc(50% - 200px);
    top: calc(50% - 200px);
    z-index: 0;

    &:after {
      content: '';
      border-radius: 50%;
      position: absolute;
      width: 480px;
      height: 480px;
      top: calc(50% - 240px);
      left: calc(50% - 240px);
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  .text-shadow {
    letter-spacing: -0.64px;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  }

  .text-overlay {
    opacity: 0;
    line-height: 48px;
  }

  .filmr-video {
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .center-container {
    /* &:after {
      content: '';
      background-color: #235fdf;
      position: absolute;
      width: 800px;
      height: 800px;
      opacity: 0;
      top: 20%;
      z-index: 0;
      border-radius: 50%;
      animation: ${scaleIn} 0.3s 2.4s ease forwards;
    } */
  }

  @media screen and (max-height: 540px) {
    .content {
      padding-top: 1.5rem;
    }
    .filmr-heading {
      font-size: 22px;
    }
    .awards {
      display: none;
    }
  }

  @media (max-width: 360px) {
    .text-overlay {
      font-size: 36px;
      top: 1rem;
    }
  }

  @media (min-width: 768px) {
    .center-container {
      display: none;
    }
  }
`;
